import React, { useEffect, useRef, useState } from "react";
import { BANNER_URL, PRODUCT_URL, TEACHER_URL } from "../../api/URLs";
import { deleteDataRequest, getDataRequest, putDataRequest } from "../../api/serviceMethods";
import MessageConfirmModal from "../../components/messageModal/MessageConfirmModal";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import TableListAvantGardeCreativity from "./TableListAvantGardeCreativity";
import AvantGardeCreativityHeader from "./AvantGardeCreativityHeader";
import BannerHeader from "./BannerHeader";
import TableListBanner from "./TableListBanner";

const BannerPage = (props) => {
  const {toggleView} = props
  const [viewType, setViewType] = useState('table');
  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [magazineData, setMagazineData] = useState([])
  const messageModalRef = useRef('')
  const [dates, setDates] = useState([null, null]);
  const { t } = useTranslation();
  const [dataObject, setDataObject] = useState({
    type: "",
    method: ""
  })
  const [tableParams, setTableParams] = useState({
      pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
      },
  });

  const initLoadProduct = async () => {
    setLoading(true);
    await getDataRequest(`${BANNER_URL}`, {
        keyword: keyword.trim(),
        category: dataObject.type,
        sortByDate: tableParams.sortOrder === "ascend" ? "asc" : "desc" ,//descend
        pageNo: tableParams.pagination.current,
        pageSize: tableParams.pagination.pageSize,
    }).then(res => {
        setLoading(false);
        if (res.status === 200) {
            setMagazineData(res?.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: res.total,
                },
            });
        }
    }).catch((err) => {
        setLoading(false);
        console.log("Error", err);
    });
};
const [isSearch, setIsSearch] = useState(true)
useEffect(() => {
  isSearch && initLoadProduct();
}, [
  tableParams.pagination?.current,
  tableParams.pagination?.pageSize,
  tableParams?.sortOrder,
  tableParams?.sortField, isSearch,
  JSON.stringify(tableParams.filters), viewType]);

  const insertParams = (dataObject) => {
    const memberPayload = {
      previewFile: {
        url: dataObject&& dataObject.privateFile && dataObject.privateFile.url,
        size: dataObject&& dataObject.privateFile && dataObject.privateFile.size,
        fileName: dataObject&& dataObject.privateFile && dataObject.privateFile.fileName,
        page: dataObject&& dataObject.privateFile && dataObject.privateFile.page,
      },
      status: !dataObject.status
    }
    return memberPayload
  }
  const hadleUpdateMagazine = async (item) => {
    try {
      const memberPayload = insertParams(item)
      setLoading(true);
      await putDataRequest(`${BANNER_URL}/${item.id} `, memberPayload)
        .then((res) => {
          if (res.status === 200) {
            initLoadProduct()
            messageModalRef.current.showSuccessConfirmsAutoClose(
              t('bannerMesage.updateStatusSuccess', {
                bannerId: res?.bannerId,
              }), () => { }, "", true);
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(t(`Server Error!`), () => { }, "", true);
    }
  }

  const deleteMagazineData = async (item) => {
    messageModalRef.current.showWarningConfirm(t('Are you sure you want to delete this banner management?'), async () => {
      setLoading(true)
      await deleteDataRequest(`${BANNER_URL}/${item.id}`).then((res) => {
        messageModalRef.current.showSuccessConfirmsAutoClose(res && t(res.message), () => { }, "", true);
        initLoadProduct();
        setLoading(false)
      }).catch((err) => {
        messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        setLoading(false)
      });
    }, "", true);
  };

  return (
    <div className="box-shadow h-100 w-100">
      <div className="w-100 h-100 overflow-auto">
        <div className="w-100">
          <div className="w-100 mt-3" style={{ padding: "0px 25px" }}>
            <BannerHeader 
              viewType={viewType} setViewType={setViewType} 
              modalOpen={modalOpen} setModalOpen={setModalOpen}
              magazineData={magazineData} tableParams={tableParams} 
              setTableParams={setTableParams} loading={loading} 
              setLoading={setLoading} dates={dates} setDates={setDates}
              initLoadProduct={() => {
                setIsSearch(false)
                setTimeout(() => {
                  setIsSearch(true)
                }, 100);
              }} 
              setKeyword={setKeyword}
              messageModalRef={messageModalRef}
              toggleView={toggleView}
              dataObject={dataObject} 
              setDataObject={setDataObject}
            />
            <TableListBanner
              viewType={viewType} setViewType={setViewType} 
              modalOpen={modalOpen} setModalOpen={setModalOpen}
              magazineData={magazineData} tableParams={tableParams} 
              setTableParams={setTableParams} loading={loading} 
              setLoading={setLoading} hadleUpdateMagazine={hadleUpdateMagazine}
              deleteMagazineData={deleteMagazineData}
              toggleView={toggleView} initLoadProduct={initLoadProduct}
            />
          </div>
        </div>
      </div>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </div>
  )
}

export default BannerPage;